'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var plugin = require('tailwindcss/plugin');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var plugin__default = /*#__PURE__*/_interopDefaultCompat(plugin);

var hideScrollbar = plugin__default.default(({ addUtilities })=>{
    addUtilities({
        '.scrollbar-hide': {
            /* IE and Edge */ '-ms-overflow-style': 'none',
            /* Firefox */ 'scrollbar-width': 'none',
            /* Safari and Chrome */ '&::-webkit-scrollbar': {
                display: 'none'
            }
        }
    });
});

exports.default = hideScrollbar;
//# sourceMappingURL=hideScrollbar.js.map
